import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useLocation } from 'react-router-dom';
import useStorage from '../../../../hooks/useStorage';

const { Box, Button, Title, Table } = vp;

type FC = FunctionComponent;

const SignersDetailsContainer: FC = () => {
  const query = new URLSearchParams(useLocation().search);
  const state = {
    signer: {
      ID: query.get('ID') || '',
      FullName: query.get('FullName') || '',
      DOB: query.get('DOB') || '',
      Occupation: query.get('Occupation') || '',
      EmailAddress: query.get('EmailAddress') || '',
      HomeAddress: query.get('HomeAddress') || '',
      DocumentSigned: query.get('DocumentSigned') || '',
      DateAdded: query.get('DateAdded') || '',
    },
  };
  const {
    signerCreation: { storeSignerCreation },
  } = useStorage();

  const tableProps1: vp.TableProps = {
    name: 'signer-details-list1',
    variant: 'form',
    columns: {
      FullName: { header: 'Full Name*', align: 'left' },
      EmailAddress: { header: 'Email Address*', align: 'left' },
      Title: { header: 'Title*', align: 'left' },
    },
    rows:
      Object.values(state).map((signer) => ({
        FullName: signer.FullName,
        EmailAddress: signer.EmailAddress,
        Title: signer.Occupation,
      })) || [],
  };

  return (
    <>
      <Box mt="lg" mb="lg" flx="col">
        <Title title="Signer Details" />
      </Box>
      <Table {...tableProps1} />
      <Box jc="fe" pt="lg" mt="lg" gap="md">
        <Button
          id="back-to-signers-btn"
          label="Back"
          color="primary"
          width="223px"
          noShadow
          round
          onClick={() => {
            history.back();
            storeSignerCreation('signerChange');
          }}
        />
      </Box>
    </>
  );
};

export default SignersDetailsContainer;
